import keyBy from 'lodash/keyBy';
import sortBy from 'lodash/sortBy';
import uniq from 'lodash/uniq';
import { useMemo } from 'react';

import { REQUEST_STALE_TIME_IN_MS } from '@/constants';
import useListService from '@/data/hook/useListService';
import { klassesQueryKeys } from '@/data/services/querykeys';

type UseKlassesMapProps = {
  klassIds: number[];
};

export default function useKlassesMap({ klassIds }: UseKlassesMapProps) {
  const ids = sortBy(uniq(klassIds));

  const { results: klasses, isFetching } = useListService({
    ...klassesQueryKeys.list({ id: ids, pageSize: ids.length }),
    enabled: ids.length > 0,
    staleTime: REQUEST_STALE_TIME_IN_MS,
    keepPreviousData: true,
  });

  const klassesMap = useMemo(() => keyBy(klasses, 'id'), [klasses]);

  return { klassesMap, isLoading: isFetching };
}
